import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsCreatorLearners } from '@/learnpaths-creator/components/LearnpathsCreatorLearners/LearnpathsCreatorLearners'
import LearnpathsAddElementsRedirect from '@/learnpaths/components/LearnpathsAddElementsRedirect/LearnpathsAddElementsRedirect'
import { useManagedLearnpath } from '@/learnpaths/queries/useManagedLearnpath'

export const Route = createFileRoute(
  '/company/learnpaths/add/learners/$learnpathId',
)({
  component: LearnpathsAddLearners,
})

function LearnpathsAddLearners() {
  const { learnpathId } = Route.useParams()
  const { data } = useManagedLearnpath({ learnpathId })

  if (data?.is_course) {
    return null
  }

  return (
    <LearnpathsAddElementsRedirect>
      <LearnpathsCreatorLearners />
    </LearnpathsAddElementsRedirect>
  )
}
